<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>嘉兴侧塔柱</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <!-- <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div> -->
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">绍兴</span>
        </div>
        <div class="cable-img">
          <div class="tower-name tower-name-z3">Z3</div>
          <div class="tower-name tower-name-z4">Z4</div>
          <div class="tower-name tower-name-z5">Z5</div>

          <el-tooltip class="station-block station-block-z3-top" content="Z3上塔T1除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station2"></router-link>
          </el-tooltip>
          <div class="stati sta-z3-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z3上塔T1除湿机",
                    humidityTooltipErrorDehumidifierZ3TowerTop,
                    humidityAllowedMaxDehumidifierZ3TowerTop,
                    runningDehumidifierZ3TowerTop,
                    malfunctionDehumidifierZ3TowerTop
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z3上塔上循环风", humidityTooltipErrorZ3TowerTopEnvironmentUp,
                  humidityAllowedMaxZ3TowerTopEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z3上塔中循环风", humidityTooltipErrorZ3TowerTopEnvironmentMid,
                    humidityAllowedMaxZ3TowerTopEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z3上塔下循环风", humidityTooltipErrorZ3TowerTopEnvironmentDown,
                    humidityAllowedMaxZ3TowerTopEnvironmentDown)
                }}
              </div>
              <div :class="errorZ3TowerTop" class="state-info bottom-pos"
                @dblclick="hrefToScenario('b459fe14-36fe-481b-a51a-7e7325dd9ae1')"
                v-loading="stationNameLoadingDict['stationT1']">
                <p>
                  <span class="bold">Z3上塔T1除湿机</span>
                  <span :class="runningClassZ3TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ3TowerTop | toFixed }}% {{ temperatureDehumidifierZ3TowerTop | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ3TowerTopEnvironmentUp | toFixed }}% {{ temperatureZ3TowerTopEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ3TowerTopEnvironmentMid | toFixed }}% {{ temperatureZ3TowerTopEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ3TowerTopEnvironmentDown | toFixed }}% {{ temperatureZ3TowerTopEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z3-mid" content="Z3中塔T2除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station1"></router-link>
          </el-tooltip>
          <div class="stati sta-z3-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z3中塔T1除湿机",
                    humidityTooltipErrorDehumidifierZ3TowerMid,
                    humidityAllowedMaxDehumidifierZ3TowerMid,
                    runningDehumidifierZ3TowerMid,
                    malfunctionDehumidifierZ3TowerMid
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z3中塔上循环风", humidityTooltipErrorZ3TowerMidEnvironmentUp,
                  humidityAllowedMaxZ3TowerMidEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z3中塔中循环风", humidityTooltipErrorZ3TowerMidEnvironmentMid,
                    humidityAllowedMaxZ3TowerMidEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z3中塔下循环风", humidityTooltipErrorZ3TowerMidEnvironmentDown,
                    humidityAllowedMaxZ3TowerMidEnvironmentDown)
                }}
              </div>
              <div :class="errorZ3TowerMid" class="state-info right-pos"
                @dblclick="hrefToScenario('24acfada-0e97-42b1-b6e7-02c064ef85a5')"
                v-loading="stationNameLoadingDict['stationT2']">
                <p>
                  <span class="bold">Z3中塔T2除湿机</span>
                  <span :class="runningClassZ3TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ3TowerMid | toFixed }}% {{ temperatureDehumidifierZ3TowerMid | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ3TowerMidEnvironmentUp | toFixed }}% {{ temperatureZ3TowerMidEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ3TowerMidEnvironmentMid | toFixed }}% {{ temperatureZ3TowerMidEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ3TowerMidEnvironmentDown | toFixed }}% {{ temperatureZ3TowerMidEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z4-top" content="Z4上塔T3除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station5"></router-link>
          </el-tooltip>
          <div class="stati sta-z4-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z4上塔T3除湿机",
                    humidityTooltipErrorDehumidifierZ4TowerTop,
                    humidityAllowedMaxDehumidifierZ4TowerTop,
                    runningDehumidifierZ4TowerTop,
                    malfunctionDehumidifierZ4TowerTop
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z4上塔上循环风", humidityTooltipErrorZ4TowerTopEnvironmentUp,
                  humidityAllowedMaxZ4TowerTopEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z4上塔中循环风", humidityTooltipErrorZ4TowerTopEnvironmentMid,
                    humidityAllowedMaxZ4TowerTopEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z4上塔下循环风", humidityTooltipErrorZ4TowerTopEnvironmentDown,
                    humidityAllowedMaxZ4TowerTopEnvironmentDown)
                }}
              </div>
              <div :class="errorZ4TowerTop" class="state-info bottom-pos"
                @dblclick="hrefToScenario('7067615d-40d3-40be-808a-a1e64da9852a')"
                v-loading="stationNameLoadingDict['stationT3']">
                <p>
                  <span class="bold">Z4上塔T3除湿机</span>
                  <span :class="runningClassZ4TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ4TowerTop | toFixed }}% {{ temperatureDehumidifierZ4TowerTop | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ4TowerTopEnvironmentUp | toFixed }}% {{ temperatureZ4TowerTopEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ4TowerTopEnvironmentMid | toFixed }}% {{ temperatureZ4TowerTopEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ4TowerTopEnvironmentDown | toFixed }}% {{ temperatureZ4TowerTopEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z4-mid" content="Z4中塔T4除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station8"></router-link>
          </el-tooltip>
          <div class="stati sta-z4-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z4中塔T4除湿机",
                    humidityTooltipErrorDehumidifierZ4TowerMid,
                    humidityAllowedMaxDehumidifierZ4TowerMid,
                    runningDehumidifierZ4TowerMid,
                    malfunctionDehumidifierZ4TowerMid
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z4中塔上循环风", humidityTooltipErrorZ4TowerMidEnvironmentUp,
                  humidityAllowedMaxZ4TowerMidEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z4中塔中循环风", humidityTooltipErrorZ4TowerMidEnvironmentMid,
                    humidityAllowedMaxZ4TowerMidEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z4中塔下循环风", humidityTooltipErrorZ4TowerMidEnvironmentDown,
                    humidityAllowedMaxZ4TowerMidEnvironmentDown)
                }}
              </div>
              <div :class="errorZ4TowerMid" class="state-info right-pos"
                @dblclick="hrefToScenario('7fadf10b-bf35-4be5-935c-d0478b579707')"
                v-loading="stationNameLoadingDict['stationT4']">
                <p>
                  <span class="bold">Z4中塔T4除湿机</span>
                  <span :class="runningClassZ4TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ4TowerMid | toFixed }}% {{ temperatureDehumidifierZ4TowerMid | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ4TowerMidEnvironmentUp | toFixed }}% {{ temperatureZ4TowerMidEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ4TowerMidEnvironmentMid | toFixed }}% {{ temperatureZ4TowerMidEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ4TowerMidEnvironmentDown | toFixed }}% {{ temperatureZ4TowerMidEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z5-top" content="Z5上塔T5除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station12"></router-link>
          </el-tooltip>
          <div class="stati sta-z5-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z5上塔T5除湿机",
                    humidityTooltipErrorDehumidifierZ5TowerTop,
                    humidityAllowedMaxDehumidifierZ5TowerTop,
                    runningDehumidifierZ5TowerTop,
                    malfunctionDehumidifierZ5TowerTop
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z5上塔上循环风", humidityTooltipErrorZ5TowerTopEnvironmentUp,
                  humidityAllowedMaxZ5TowerTopEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z5上塔中循环风", humidityTooltipErrorZ5TowerTopEnvironmentMid,
                    humidityAllowedMaxZ5TowerTopEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z5上塔下循环风", humidityTooltipErrorZ5TowerTopEnvironmentDown,
                    humidityAllowedMaxZ5TowerTopEnvironmentDown)
                }}
              </div>
              <div :class="errorZ5TowerTop" class="state-info bottom-pos"
                @dblclick="hrefToScenario('851ed832-222e-4abc-948f-c392114325df')"
                v-loading="stationNameLoadingDict['stationT5']">
                <p>
                  <span class="bold">Z5上塔T5除湿机</span>
                  <span :class="runningClassZ5TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ5TowerTop | toFixed }}% {{ temperatureDehumidifierZ5TowerTop | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ5TowerTopEnvironmentUp | toFixed }}% {{ temperatureZ5TowerTopEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ5TowerTopEnvironmentMid | toFixed }}% {{ temperatureZ5TowerTopEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ5TowerTopEnvironmentDown | toFixed }}% {{ temperatureZ5TowerTopEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z5-mid" content="Z5中塔T6除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station6"></router-link>
          </el-tooltip>
          <div class="stati sta-z5-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z5中塔T6除湿机",
                    humidityTooltipErrorDehumidifierZ5TowerMid,
                    humidityAllowedMaxDehumidifierZ5TowerMid,
                    runningDehumidifierZ5TowerMid,
                    malfunctionDehumidifierZ5TowerMid
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z5中塔上循环风", humidityTooltipErrorZ5TowerMidEnvironmentUp,
                  humidityAllowedMaxZ5TowerMidEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z5中塔中循环风", humidityTooltipErrorZ5TowerMidEnvironmentMid,
                    humidityAllowedMaxZ5TowerMidEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z5中塔下循环风", humidityTooltipErrorZ5TowerMidEnvironmentDown,
                    humidityAllowedMaxZ5TowerMidEnvironmentDown)
                }}
              </div>
              <div :class="errorZ5TowerMid" class="state-info right-pos"
                @dblclick="hrefToScenario('079371d1-b4a1-45cb-a63d-fb00b82a6bd0')"
                v-loading="stationNameLoadingDict['stationT6']">
                <p>
                  <span class="bold">Z5中塔T6除湿机</span>
                  <span :class="runningClassZ5TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ5TowerMid | toFixed }}% {{ temperatureDehumidifierZ5TowerMid | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ5TowerMidEnvironmentUp | toFixed }}% {{ temperatureZ5TowerMidEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ5TowerMidEnvironmentMid | toFixed }}% {{ temperatureZ5TowerMidEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ5TowerMidEnvironmentDown | toFixed }}% {{ temperatureZ5TowerMidEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-rigidhinge-up" content="J3-R刚性铰J1/J2除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/rigidHingeStation/station23"></router-link>
          </el-tooltip>
          <div class="stati sta-rigidhinge-up-up">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "J3-R刚性铰J1除湿机",
                    "",
                    "",
                    runningDehumidifierRigidHingeJ3RJ1,
                    malfunctionDehumidifierRigidHingeJ3RJ1
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("J1-1刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ11,
                    humidityAllowedMaxRigidHingeEnvironmentJ11)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J1-2刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ12,
                    humidityAllowedMaxRigidHingeEnvironmentJ12)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J1-3刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ13,
                    humidityAllowedMaxRigidHingeEnvironmentJ13)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J1-4刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ14,
                    humidityAllowedMaxRigidHingeEnvironmentJ14)
                }}
              </div>
              <div :class="errorRigidHingeJ3RJ1" class="state-info bottom-pos"
                @dblclick="hrefToScenario('abc09b72-7ca0-4358-b323-b0929933b265')"
                v-loading="stationNameLoadingDict['stationJ1']">
                <p>
                  <span class="bold">J3-R刚性铰J1除湿机</span>
                  <span :class="runningClassRigidHingeJ3RJ1" class="valve-sign"></span>
                </p>
                <p>
                  <span>J1-1传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ11 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ11 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J1-2传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ12 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ12 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J1-3传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ13 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ13 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J1-4传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ14 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ14 |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-rigidhinge-up-down">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "J3-R刚性铰J2除湿机",
                    "",
                    "",
                    runningDehumidifierRigidHingeJ3RJ2,
                    malfunctionDehumidifierRigidHingeJ3RJ2
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("J2-1刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ21,
                    humidityAllowedMaxRigidHingeEnvironmentJ21)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J2-2刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ22,
                    humidityAllowedMaxRigidHingeEnvironmentJ22)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J2-3刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ23,
                    humidityAllowedMaxRigidHingeEnvironmentJ23)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J2-4刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ24,
                    humidityAllowedMaxRigidHingeEnvironmentJ24)
                }}
              </div>
              <div :class="errorRigidHingeJ3RJ2" class="state-info top-pos"
                @dblclick="hrefToScenario('5d79eb49-1877-4ebc-ae8d-963e4e15b090')"
                v-loading="stationNameLoadingDict['stationJ2']">
                <p>
                  <span class="bold">J3-R刚性铰J2除湿机</span>
                  <span :class="runningClassRigidHingeJ3RJ2" class="valve-sign"></span>
                </p>
                <p>
                  <span>J2-1传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ21 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ21 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J2-2传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ22 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ22 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J2-3传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ23 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ23 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J2-4传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ24 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ24 |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>绍兴侧塔柱</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <!-- <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div> -->
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">绍兴</span>
        </div>
        <div class="cable-img image-reversed">
          <div class="tower-name tower-name-z6">Z6</div>
          <div class="tower-name tower-name-z7">Z7</div>
          <div class="tower-name tower-name-z8">Z8</div>

          <el-tooltip class="station-block station-block-z6-top" content="Z6上塔T7除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station7"></router-link>
          </el-tooltip>
          <div class="stati sta-z6-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z6上塔T7除湿机",
                    humidityTooltipErrorDehumidifierZ6TowerTop,
                    humidityAllowedMaxDehumidifierZ6TowerTop,
                    runningDehumidifierZ6TowerTop,
                    malfunctionDehumidifierZ6TowerTop
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z6上塔上循环风", humidityTooltipErrorZ6TowerTopEnvironmentUp,
                  humidityAllowedMaxZ6TowerTopEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z6上塔中循环风", humidityTooltipErrorZ6TowerTopEnvironmentMid,
                    humidityAllowedMaxZ6TowerTopEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z6上塔下循环风", humidityTooltipErrorZ6TowerTopEnvironmentDown,
                    humidityAllowedMaxZ6TowerTopEnvironmentDown)
                }}
              </div>
              <div :class="errorZ6TowerTop" class="state-info bottom-pos"
                @dblclick="hrefToScenario('1be2ccc5-5f35-47a8-9950-d7a02ddccf02')"
                v-loading="stationNameLoadingDict['stationT7']">
                <p>
                  <span class="bold">Z6上塔T7除湿机</span>
                  <span :class="runningClassZ6TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ6TowerTop | toFixed }}% {{ temperatureDehumidifierZ6TowerTop | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ6TowerTopEnvironmentUp | toFixed }}% {{ temperatureZ6TowerTopEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ6TowerTopEnvironmentMid | toFixed }}% {{ temperatureZ6TowerTopEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ6TowerTopEnvironmentDown | toFixed }}% {{ temperatureZ6TowerTopEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z6-mid" content="Z6中塔T8除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station16"></router-link>
          </el-tooltip>
          <div class="stati sta-z6-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z6中塔T7除湿机",
                    humidityTooltipErrorDehumidifierZ6TowerMid,
                    humidityAllowedMaxDehumidifierZ6TowerMid,
                    runningDehumidifierZ6TowerMid,
                    malfunctionDehumidifierZ6TowerMid
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z6中塔上循环风", humidityTooltipErrorZ6TowerMidEnvironmentUp,
                  humidityAllowedMaxZ6TowerMidEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z6中塔中循环风", humidityTooltipErrorZ6TowerMidEnvironmentMid,
                    humidityAllowedMaxZ6TowerMidEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z6中塔下循环风", humidityTooltipErrorZ6TowerMidEnvironmentDown,
                    humidityAllowedMaxZ6TowerMidEnvironmentDown)
                }}
              </div>
              <div :class="errorZ6TowerMid" class="state-info left-pos"
                @dblclick="hrefToScenario('f5f7ec2d-7fab-46d5-812d-7270c69b34aa')"
                v-loading="stationNameLoadingDict['stationT8']">
                <p>
                  <span class="bold">Z6中塔T8除湿机</span>
                  <span :class="runningClassZ6TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ6TowerMid | toFixed }}% {{ temperatureDehumidifierZ6TowerMid | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ6TowerMidEnvironmentUp | toFixed }}% {{ temperatureZ6TowerMidEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ6TowerMidEnvironmentMid | toFixed }}% {{ temperatureZ6TowerMidEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ6TowerMidEnvironmentDown | toFixed }}% {{ temperatureZ6TowerMidEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z7-top" content="Z7上塔T9除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station3"></router-link>
          </el-tooltip>
          <div class="stati sta-z7-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z7上塔T9除湿机",
                    humidityTooltipErrorDehumidifierZ7TowerTop,
                    humidityAllowedMaxDehumidifierZ7TowerTop,
                    runningDehumidifierZ7TowerTop,
                    malfunctionDehumidifierZ7TowerTop
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z7上塔上循环风", humidityTooltipErrorZ7TowerTopEnvironmentUp,
                  humidityAllowedMaxZ7TowerTopEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z7上塔中循环风", humidityTooltipErrorZ7TowerTopEnvironmentMid,
                    humidityAllowedMaxZ7TowerTopEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z7上塔下循环风", humidityTooltipErrorZ7TowerTopEnvironmentDown,
                    humidityAllowedMaxZ7TowerTopEnvironmentDown)
                }}
              </div>
              <div :class="errorZ7TowerTop" class="state-info bottom-pos"
                @dblclick="hrefToScenario('bb52c2e4-338b-4b07-b7dd-6d8d70c5bd6d')"
                v-loading="stationNameLoadingDict['stationT9']">
                <p>
                  <span class="bold">Z7上塔T9除湿机</span>
                  <span :class="runningClassZ7TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ7TowerTop | toFixed }}% {{ temperatureDehumidifierZ7TowerTop | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ7TowerTopEnvironmentUp | toFixed }}% {{ temperatureZ7TowerTopEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ7TowerTopEnvironmentMid | toFixed }}% {{ temperatureZ7TowerTopEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ7TowerTopEnvironmentDown | toFixed }}% {{ temperatureZ7TowerTopEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z7-mid" content="Z7中塔T10除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station10"></router-link>
          </el-tooltip>
          <div class="stati sta-z7-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z7中塔T9除湿机",
                    humidityTooltipErrorDehumidifierZ7TowerMid,
                    humidityAllowedMaxDehumidifierZ7TowerMid,
                    runningDehumidifierZ7TowerMid,
                    malfunctionDehumidifierZ7TowerMid
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z7中塔上循环风", humidityTooltipErrorZ7TowerMidEnvironmentUp,
                  humidityAllowedMaxZ7TowerMidEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z7中塔中循环风", humidityTooltipErrorZ7TowerMidEnvironmentMid,
                    humidityAllowedMaxZ7TowerMidEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z7中塔下循环风", humidityTooltipErrorZ7TowerMidEnvironmentDown,
                    humidityAllowedMaxZ7TowerMidEnvironmentDown)
                }}
              </div>
              <div :class="errorZ7TowerMid" class="state-info left-pos"
                @dblclick="hrefToScenario('c3c889fb-d28c-4ef0-a73d-8d39a1aebd2b')"
                v-loading="stationNameLoadingDict['stationT10']">
                <p>
                  <span class="bold">Z7中塔T10除湿机</span>
                  <span :class="runningClassZ7TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ7TowerMid | toFixed }}% {{ temperatureDehumidifierZ7TowerMid | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ7TowerMidEnvironmentUp | toFixed }}% {{ temperatureZ7TowerMidEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ7TowerMidEnvironmentMid | toFixed }}% {{ temperatureZ7TowerMidEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ7TowerMidEnvironmentDown | toFixed }}% {{ temperatureZ7TowerMidEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z8-top" content="Z8上塔T11除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station4"></router-link>
          </el-tooltip>
          <div class="stati sta-z8-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z8上塔T11除湿机",
                    humidityTooltipErrorDehumidifierZ8TowerTop,
                    humidityAllowedMaxDehumidifierZ8TowerTop,
                    runningDehumidifierZ8TowerTop,
                    malfunctionDehumidifierZ8TowerTop
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z8上塔上循环风", humidityTooltipErrorZ8TowerTopEnvironmentUp,
                  humidityAllowedMaxZ8TowerTopEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z8上塔中循环风", humidityTooltipErrorZ8TowerTopEnvironmentMid,
                    humidityAllowedMaxZ8TowerTopEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z8上塔下循环风", humidityTooltipErrorZ8TowerTopEnvironmentDown,
                    humidityAllowedMaxZ8TowerTopEnvironmentDown)
                }}
              </div>
              <div :class="errorZ8TowerTop" class="state-info bottom-pos"
                @dblclick="hrefToScenario('e9d270a9-5b97-4de2-a1b2-b51504528eb3')"
                v-loading="stationNameLoadingDict['stationT11']">
                <p>
                  <span class="bold">Z8上塔T11除湿机</span>
                  <span :class="runningClassZ8TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ8TowerTop | toFixed }}% {{ temperatureDehumidifierZ8TowerTop | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ8TowerTopEnvironmentUp | toFixed }}% {{ temperatureZ8TowerTopEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ8TowerTopEnvironmentMid | toFixed }}% {{ temperatureZ8TowerTopEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ8TowerTopEnvironmentDown | toFixed }}% {{ temperatureZ8TowerTopEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z8-mid" content="Z8中塔T12除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station29"></router-link>
          </el-tooltip>
          <div class="stati sta-z8-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "Z8中塔T11除湿机",
                    humidityTooltipErrorDehumidifierZ8TowerMid,
                    humidityAllowedMaxDehumidifierZ8TowerMid,
                    runningDehumidifierZ8TowerMid,
                    malfunctionDehumidifierZ8TowerMid
                  )
                }}
                <br />
                {{ assembleTooltip_sensor("Z8中塔上循环风", humidityTooltipErrorZ8TowerMidEnvironmentUp,
                  humidityAllowedMaxZ8TowerMidEnvironmentUp) }}
                <br />
                {{
                  assembleTooltip_sensor("Z8中塔中循环风", humidityTooltipErrorZ8TowerMidEnvironmentMid,
                    humidityAllowedMaxZ8TowerMidEnvironmentMid)
                }}
                <br />
                {{
                  assembleTooltip_sensor("Z8中塔下循环风", humidityTooltipErrorZ8TowerMidEnvironmentDown,
                    humidityAllowedMaxZ8TowerMidEnvironmentDown)
                }}
              </div>
              <div :class="errorZ8TowerMid" class="state-info left-pos"
                @dblclick="hrefToScenario('fa9b782e-cc7a-4938-9ad6-9318c072ac9a')"
                v-loading="stationNameLoadingDict['stationT12']">
                <p>
                  <span class="bold">Z8中塔T12除湿机</span>
                  <span :class="runningClassZ8TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>除湿机</span>
                  <span>{{ humidityDehumidifierZ8TowerMid | toFixed }}% {{ temperatureDehumidifierZ8TowerMid | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>上循环风</span>
                  <span>{{ humidityZ8TowerMidEnvironmentUp | toFixed }}% {{ temperatureZ8TowerMidEnvironmentUp | toFixed
                  }}°C</span>
                </p>
                <p>
                  <span>中循环风</span>
                  <span>{{ humidityZ8TowerMidEnvironmentMid | toFixed }}% {{ temperatureZ8TowerMidEnvironmentMid |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>下循环风</span>
                  <span>{{ humidityZ8TowerMidEnvironmentDown | toFixed }}% {{ temperatureZ8TowerMidEnvironmentDown |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-rigidhinge-down" content="J3-L刚性铰J3/J4除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/rigidHingeStation/station22"></router-link>
          </el-tooltip>
          <div class="stati sta-rigidhinge-down-up">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "J3-L刚性铰J3除湿机",
                    "",
                    "",
                    runningDehumidifierRigidHingeJ3LJ3,
                    malfunctionDehumidifierRigidHingeJ3LJ3
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("J3-1刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ31,
                    humidityAllowedMaxRigidHingeEnvironmentJ31)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J3-2刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ32,
                    humidityAllowedMaxRigidHingeEnvironmentJ32)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J3-3刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ33,
                    humidityAllowedMaxRigidHingeEnvironmentJ33)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J3-4刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ34,
                    humidityAllowedMaxRigidHingeEnvironmentJ34)
                }}
              </div>
              <div :class="errorRigidHingeJ3LJ3" class="state-info bottom-pos"
                @dblclick="hrefToScenario('1e8f508b-e537-467b-a117-88e9f67a1212')"
                v-loading="stationNameLoadingDict['stationJ3']">
                <p>
                  <span class="bold">J3-L刚性铰J3除湿机</span>
                  <span :class="runningClassRigidHingeJ3LJ3" class="valve-sign"></span>
                </p>
                <p>
                  <span>J3-1传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ31 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ31 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J3-2传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ32 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ32 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J3-3传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ33 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ33 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J3-4传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ34 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ34 |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-rigidhinge-down-down">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "J3-L刚性铰J4除湿机",
                    "",
                    "",
                    runningDehumidifierRigidHingeJ3LJ4,
                    malfunctionDehumidifierRigidHingeJ3LJ4
                  )
                }}
                <br />
                {{
                  assembleTooltip_sensor("J4-1刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ41,
                    humidityAllowedMaxRigidHingeEnvironmentJ41)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J4-2刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ42,
                    humidityAllowedMaxRigidHingeEnvironmentJ42)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J4-3刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ43,
                    humidityAllowedMaxRigidHingeEnvironmentJ43)
                }}
                <br />
                {{
                  assembleTooltip_sensor("J4-4刚性铰传感器", humidityTooltipErrorRigidHingeEnvironmentJ44,
                    humidityAllowedMaxRigidHingeEnvironmentJ44)
                }}
              </div>
              <div :class="errorRigidHingeJ3LJ4" class="state-info top-pos"
                @dblclick="hrefToScenario('a955afa1-9ec0-49bb-8ea7-7f4804d383d7')"
                v-loading="stationNameLoadingDict['stationJ4']">
                <p>
                  <span class="bold">J3-L刚性铰J4除湿机</span>
                  <span :class="runningClassRigidHingeJ3LJ4" class="valve-sign"></span>
                </p>
                <p>
                  <span>J4-1传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ41 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ41 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J4-2传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ42 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ42 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J4-3传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ43 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ43 |
                    toFixed }}°C</span>
                </p>
                <p>
                  <span>J4-4传感器</span>
                  <span>{{ humidityRigidHingeEnvironmentJ44 | toFixed }}% {{ temperatureRigidHingeEnvironmentJ44 |
                    toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "jiashao",
      bridgeId: "3b04991c-3662-4948-930e-ac537ed82fd3",

      //humidity, temperature, pressure, flow, volume
      //humidity, temperature
      humidityDehumidifierZ3TowerTop: "--",
      humidityDehumidifierZ3TowerMid: "--",
      humidityDehumidifierZ4TowerTop: "--",
      humidityDehumidifierZ4TowerMid: "--",
      humidityDehumidifierZ5TowerTop: "--",
      humidityDehumidifierZ5TowerMid: "--",
      humidityDehumidifierZ6TowerTop: "--",
      humidityDehumidifierZ6TowerMid: "--",
      humidityDehumidifierZ7TowerTop: "--",
      humidityDehumidifierZ7TowerMid: "--",
      humidityDehumidifierZ8TowerTop: "--",
      humidityDehumidifierZ8TowerMid: "--",

      temperatureDehumidifierZ3TowerTop: "--",
      temperatureDehumidifierZ3TowerMid: "--",
      temperatureDehumidifierZ4TowerTop: "--",
      temperatureDehumidifierZ4TowerMid: "--",
      temperatureDehumidifierZ5TowerTop: "--",
      temperatureDehumidifierZ5TowerMid: "--",
      temperatureDehumidifierZ6TowerTop: "--",
      temperatureDehumidifierZ6TowerMid: "--",
      temperatureDehumidifierZ7TowerTop: "--",
      temperatureDehumidifierZ7TowerMid: "--",
      temperatureDehumidifierZ8TowerTop: "--",
      temperatureDehumidifierZ8TowerMid: "--",

      humidityZ3TowerTopEnvironmentUp: "--",
      humidityZ3TowerTopEnvironmentMid: "--",
      humidityZ3TowerTopEnvironmentDown: "--",
      humidityZ3TowerMidEnvironmentUp: "--",
      humidityZ3TowerMidEnvironmentMid: "--",
      humidityZ3TowerMidEnvironmentDown: "--",
      humidityZ4TowerTopEnvironmentUp: "--",
      humidityZ4TowerTopEnvironmentMid: "--",
      humidityZ4TowerTopEnvironmentDown: "--",
      humidityZ4TowerMidEnvironmentUp: "--",
      humidityZ4TowerMidEnvironmentMid: "--",
      humidityZ4TowerMidEnvironmentDown: "--",
      humidityZ5TowerTopEnvironmentUp: "--",
      humidityZ5TowerTopEnvironmentMid: "--",
      humidityZ5TowerTopEnvironmentDown: "--",
      humidityZ5TowerMidEnvironmentUp: "--",
      humidityZ5TowerMidEnvironmentMid: "--",
      humidityZ5TowerMidEnvironmentDown: "--",
      humidityZ6TowerTopEnvironmentUp: "--",
      humidityZ6TowerTopEnvironmentMid: "--",
      humidityZ6TowerTopEnvironmentDown: "--",
      humidityZ6TowerMidEnvironmentUp: "--",
      humidityZ6TowerMidEnvironmentMid: "--",
      humidityZ6TowerMidEnvironmentDown: "--",
      humidityZ7TowerTopEnvironmentUp: "--",
      humidityZ7TowerTopEnvironmentMid: "--",
      humidityZ7TowerTopEnvironmentDown: "--",
      humidityZ7TowerMidEnvironmentUp: "--",
      humidityZ7TowerMidEnvironmentMid: "--",
      humidityZ7TowerMidEnvironmentDown: "--",
      humidityZ8TowerTopEnvironmentUp: "--",
      humidityZ8TowerTopEnvironmentMid: "--",
      humidityZ8TowerTopEnvironmentDown: "--",
      humidityZ8TowerMidEnvironmentUp: "--",
      humidityZ8TowerMidEnvironmentMid: "--",
      humidityZ8TowerMidEnvironmentDown: "--",

      humidityRigidHingeEnvironmentJ11: "--",
      humidityRigidHingeEnvironmentJ12: "--",
      humidityRigidHingeEnvironmentJ13: "--",
      humidityRigidHingeEnvironmentJ14: "--",
      humidityRigidHingeEnvironmentJ21: "--",
      humidityRigidHingeEnvironmentJ22: "--",
      humidityRigidHingeEnvironmentJ23: "--",
      humidityRigidHingeEnvironmentJ24: "--",
      humidityRigidHingeEnvironmentJ31: "--",
      humidityRigidHingeEnvironmentJ32: "--",
      humidityRigidHingeEnvironmentJ33: "--",
      humidityRigidHingeEnvironmentJ34: "--",
      humidityRigidHingeEnvironmentJ41: "--",
      humidityRigidHingeEnvironmentJ42: "--",
      humidityRigidHingeEnvironmentJ43: "--",
      humidityRigidHingeEnvironmentJ44: "--",

      temperatureZ3TowerTopEnvironmentUp: "--",
      temperatureZ3TowerTopEnvironmentMid: "--",
      temperatureZ3TowerTopEnvironmentDown: "--",
      temperatureZ3TowerMidEnvironmentUp: "--",
      temperatureZ3TowerMidEnvironmentMid: "--",
      temperatureZ3TowerMidEnvironmentDown: "--",
      temperatureZ4TowerTopEnvironmentUp: "--",
      temperatureZ4TowerTopEnvironmentMid: "--",
      temperatureZ4TowerTopEnvironmentDown: "--",
      temperatureZ4TowerMidEnvironmentUp: "--",
      temperatureZ4TowerMidEnvironmentMid: "--",
      temperatureZ4TowerMidEnvironmentDown: "--",
      temperatureZ5TowerTopEnvironmentUp: "--",
      temperatureZ5TowerTopEnvironmentMid: "--",
      temperatureZ5TowerTopEnvironmentDown: "--",
      temperatureZ5TowerMidEnvironmentUp: "--",
      temperatureZ5TowerMidEnvironmentMid: "--",
      temperatureZ5TowerMidEnvironmentDown: "--",
      temperatureZ6TowerTopEnvironmentUp: "--",
      temperatureZ6TowerTopEnvironmentMid: "--",
      temperatureZ6TowerTopEnvironmentDown: "--",
      temperatureZ6TowerMidEnvironmentUp: "--",
      temperatureZ6TowerMidEnvironmentMid: "--",
      temperatureZ6TowerMidEnvironmentDown: "--",
      temperatureZ7TowerTopEnvironmentUp: "--",
      temperatureZ7TowerTopEnvironmentMid: "--",
      temperatureZ7TowerTopEnvironmentDown: "--",
      temperatureZ7TowerMidEnvironmentUp: "--",
      temperatureZ7TowerMidEnvironmentMid: "--",
      temperatureZ7TowerMidEnvironmentDown: "--",
      temperatureZ8TowerTopEnvironmentUp: "--",
      temperatureZ8TowerTopEnvironmentMid: "--",
      temperatureZ8TowerTopEnvironmentDown: "--",
      temperatureZ8TowerMidEnvironmentUp: "--",
      temperatureZ8TowerMidEnvironmentMid: "--",
      temperatureZ8TowerMidEnvironmentDown: "--",

      temperatureRigidHingeEnvironmentJ11: "--",
      temperatureRigidHingeEnvironmentJ12: "--",
      temperatureRigidHingeEnvironmentJ13: "--",
      temperatureRigidHingeEnvironmentJ14: "--",
      temperatureRigidHingeEnvironmentJ21: "--",
      temperatureRigidHingeEnvironmentJ22: "--",
      temperatureRigidHingeEnvironmentJ23: "--",
      temperatureRigidHingeEnvironmentJ24: "--",
      temperatureRigidHingeEnvironmentJ31: "--",
      temperatureRigidHingeEnvironmentJ32: "--",
      temperatureRigidHingeEnvironmentJ33: "--",
      temperatureRigidHingeEnvironmentJ34: "--",
      temperatureRigidHingeEnvironmentJ41: "--",
      temperatureRigidHingeEnvironmentJ42: "--",
      temperatureRigidHingeEnvironmentJ43: "--",
      temperatureRigidHingeEnvironmentJ44: "--",

      //running
      runningDehumidifierZ3TowerTop: "--",
      runningDehumidifierZ3TowerMid: "--",
      runningDehumidifierZ4TowerTop: "--",
      runningDehumidifierZ4TowerMid: "--",
      runningDehumidifierZ5TowerTop: "--",
      runningDehumidifierZ5TowerMid: "--",
      runningDehumidifierZ6TowerTop: "--",
      runningDehumidifierZ6TowerMid: "--",
      runningDehumidifierZ7TowerTop: "--",
      runningDehumidifierZ7TowerMid: "--",
      runningDehumidifierZ8TowerTop: "--",
      runningDehumidifierZ8TowerMid: "--",

      runningDehumidifierRigidHingeJ3RJ1: "--",
      runningDehumidifierRigidHingeJ3RJ2: "--",
      runningDehumidifierRigidHingeJ3LJ3: "--",
      runningDehumidifierRigidHingeJ3LJ4: "--",

      //malfunction
      malfunctionDehumidifierZ3TowerTop: "--",
      malfunctionDehumidifierZ3TowerMid: "--",
      malfunctionDehumidifierZ4TowerTop: "--",
      malfunctionDehumidifierZ4TowerMid: "--",
      malfunctionDehumidifierZ5TowerTop: "--",
      malfunctionDehumidifierZ5TowerMid: "--",
      malfunctionDehumidifierZ6TowerTop: "--",
      malfunctionDehumidifierZ6TowerMid: "--",
      malfunctionDehumidifierZ7TowerTop: "--",
      malfunctionDehumidifierZ7TowerMid: "--",
      malfunctionDehumidifierZ8TowerTop: "--",
      malfunctionDehumidifierZ8TowerMid: "--",

      malfunctionDehumidifierRigidHingeJ3RJ1: "--",
      malfunctionDehumidifierRigidHingeJ3RJ2: "--",
      malfunctionDehumidifierRigidHingeJ3LJ3: "--",
      malfunctionDehumidifierRigidHingeJ3LJ4: "--",

      //error
      errorZ3TowerTop: "--",
      errorZ3TowerMid: "--",
      errorZ4TowerTop: "--",
      errorZ4TowerMid: "--",
      errorZ5TowerTop: "--",
      errorZ5TowerMid: "--",
      errorZ6TowerTop: "--",
      errorZ6TowerMid: "--",
      errorZ7TowerTop: "--",
      errorZ7TowerMid: "--",
      errorZ8TowerTop: "--",
      errorZ8TowerMid: "--",

      errorRigidHingeJ3RJ1: "--",
      errorRigidHingeJ3RJ2: "--",
      errorRigidHingeJ3LJ3: "--",
      errorRigidHingeJ3LJ4: "--",

      //running class
      runningClassZ3TowerTop: "--",
      runningClassZ3TowerMid: "--",
      runningClassZ4TowerTop: "--",
      runningClassZ4TowerMid: "--",
      runningClassZ5TowerTop: "--",
      runningClassZ5TowerMid: "--",
      runningClassZ6TowerTop: "--",
      runningClassZ6TowerMid: "--",
      runningClassZ7TowerTop: "--",
      runningClassZ7TowerMid: "--",
      runningClassZ8TowerTop: "--",
      runningClassZ8TowerMid: "--",

      runningClassRigidHingeJ3RJ1: "--",
      runningClassRigidHingeJ3RJ2: "--",
      runningClassRigidHingeJ3LJ3: "--",
      runningClassRigidHingeJ3LJ4: "--",

      //humidity allowed max
      humidityAllowedMaxDehumidifierZ3TowerTop: "--",
      humidityAllowedMaxDehumidifierZ3TowerMid: "--",
      humidityAllowedMaxDehumidifierZ4TowerTop: "--",
      humidityAllowedMaxDehumidifierZ4TowerMid: "--",
      humidityAllowedMaxDehumidifierZ5TowerTop: "--",
      humidityAllowedMaxDehumidifierZ5TowerMid: "--",
      humidityAllowedMaxDehumidifierZ6TowerTop: "--",
      humidityAllowedMaxDehumidifierZ6TowerMid: "--",
      humidityAllowedMaxDehumidifierZ7TowerTop: "--",
      humidityAllowedMaxDehumidifierZ7TowerMid: "--",
      humidityAllowedMaxDehumidifierZ8TowerTop: "--",
      humidityAllowedMaxDehumidifierZ8TowerMid: "--",

      humidityAllowedMaxZ3TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ3TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ3TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ3TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ3TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ3TowerMidEnvironmentDown: "--",
      humidityAllowedMaxZ4TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ4TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ4TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ4TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ4TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ4TowerMidEnvironmentDown: "--",
      humidityAllowedMaxZ5TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ5TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ5TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ5TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ5TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ5TowerMidEnvironmentDown: "--",
      humidityAllowedMaxZ6TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ6TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ6TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ6TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ6TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ6TowerMidEnvironmentDown: "--",
      humidityAllowedMaxZ7TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ7TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ7TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ7TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ7TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ7TowerMidEnvironmentDown: "--",
      humidityAllowedMaxZ8TowerTopEnvironmentUp: "--",
      humidityAllowedMaxZ8TowerTopEnvironmentMid: "--",
      humidityAllowedMaxZ8TowerTopEnvironmentDown: "--",
      humidityAllowedMaxZ8TowerMidEnvironmentUp: "--",
      humidityAllowedMaxZ8TowerMidEnvironmentMid: "--",
      humidityAllowedMaxZ8TowerMidEnvironmentDown: "--",

      humidityAllowedMaxRigidHingeEnvironmentJ11: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ12: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ13: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ14: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ21: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ22: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ23: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ24: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ31: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ32: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ33: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ34: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ41: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ42: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ43: "--",
      humidityAllowedMaxRigidHingeEnvironmentJ44: "--",

      //humidity tooltip error
      humidityTooltipErrorDehumidifierZ3TowerTop: "--",
      humidityTooltipErrorDehumidifierZ3TowerMid: "--",
      humidityTooltipErrorDehumidifierZ4TowerTop: "--",
      humidityTooltipErrorDehumidifierZ4TowerMid: "--",
      humidityTooltipErrorDehumidifierZ5TowerTop: "--",
      humidityTooltipErrorDehumidifierZ5TowerMid: "--",
      humidityTooltipErrorDehumidifierZ6TowerTop: "--",
      humidityTooltipErrorDehumidifierZ6TowerMid: "--",
      humidityTooltipErrorDehumidifierZ7TowerTop: "--",
      humidityTooltipErrorDehumidifierZ7TowerMid: "--",
      humidityTooltipErrorDehumidifierZ8TowerTop: "--",
      humidityTooltipErrorDehumidifierZ8TowerMid: "--",

      humidityTooltipErrorZ3TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ3TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ3TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ3TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ3TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ3TowerMidEnvironmentDown: "--",
      humidityTooltipErrorZ4TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ4TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ4TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ4TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ4TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ4TowerMidEnvironmentDown: "--",
      humidityTooltipErrorZ5TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ5TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ5TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ5TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ5TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ5TowerMidEnvironmentDown: "--",
      humidityTooltipErrorZ6TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ6TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ6TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ6TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ6TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ6TowerMidEnvironmentDown: "--",
      humidityTooltipErrorZ7TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ7TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ7TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ7TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ7TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ7TowerMidEnvironmentDown: "--",
      humidityTooltipErrorZ8TowerTopEnvironmentUp: "--",
      humidityTooltipErrorZ8TowerTopEnvironmentMid: "--",
      humidityTooltipErrorZ8TowerTopEnvironmentDown: "--",
      humidityTooltipErrorZ8TowerMidEnvironmentUp: "--",
      humidityTooltipErrorZ8TowerMidEnvironmentMid: "--",
      humidityTooltipErrorZ8TowerMidEnvironmentDown: "--",

      humidityTooltipErrorRigidHingeEnvironmentJ11: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ12: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ13: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ14: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ21: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ22: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ23: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ24: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ31: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ32: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ33: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ34: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ41: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ42: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ43: "--",
      humidityTooltipErrorRigidHingeEnvironmentJ44: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityDehumidifierZ3TowerMid: "91ae8484-fa72-4536-bbcf-227485d00984",
        humidityDehumidifierZ3TowerTop: "a8355f4b-f4f3-4175-bb43-48b6406edf37",
        humidityDehumidifierZ4TowerMid: "5d116a33-9429-4ea6-9c12-70ca1a3615c9",
        humidityDehumidifierZ4TowerTop: "1a50053a-6642-4b2f-8485-448ad89d99d0",
        humidityDehumidifierZ5TowerMid: "e63f2494-2009-431b-b169-d56c178fcc02",
        humidityDehumidifierZ5TowerTop: "7c6e3109-18ff-4c72-8a86-1bf25ec57260",
        humidityDehumidifierZ6TowerMid: "7d85ad73-ed97-488f-a041-2a5a6a6be417",
        humidityDehumidifierZ6TowerTop: "4404eb6b-a447-45cc-8739-9dd6d7b5c1c1",
        humidityDehumidifierZ7TowerMid: "b1831c64-d258-498a-9323-4fba75f44760",
        humidityDehumidifierZ7TowerTop: "8635be2d-8dbb-4407-b101-3fc48e399a6c",
        humidityDehumidifierZ8TowerMid: "ad9ed67f-1dbf-4656-9fdd-e0f8ab65bd9f",
        humidityDehumidifierZ8TowerTop: "6a1c4917-87b6-46fa-8112-d81e787c680a",

        temperatureDehumidifierZ3TowerMid: "d37a3c57-8c3d-4054-bdc8-fe446f3927b9",
        temperatureDehumidifierZ3TowerTop: "64855950-bd6c-4163-ae4e-2457a590b424",
        temperatureDehumidifierZ4TowerMid: "06636180-c748-4cbd-b017-041253682a1b",
        temperatureDehumidifierZ4TowerTop: "f54a7096-7073-4dee-82fd-59027ccb1b29",
        temperatureDehumidifierZ5TowerMid: "29678169-d33d-4b7b-b173-0fe4b22f8b02",
        temperatureDehumidifierZ5TowerTop: "795fdd42-e9dd-48a5-8c92-d00734b280fa",
        temperatureDehumidifierZ6TowerMid: "13f6ed68-8425-40d6-b076-694b6bcc445e",
        temperatureDehumidifierZ6TowerTop: "01742421-cc73-45ae-a4db-6536f26d9255",
        temperatureDehumidifierZ7TowerMid: "3e8949c8-d51c-4d31-9d4c-ef0a5e4e976e",
        temperatureDehumidifierZ7TowerTop: "ac6ab09e-9e2e-45da-a69a-110f71ab85fa",
        temperatureDehumidifierZ8TowerMid: "87312290-24ad-4277-971d-0176aa84c5c7",
        temperatureDehumidifierZ8TowerTop: "3b5eda18-9a61-4724-8774-560d362db738",

        humidityZ3TowerMidEnvironmentDown: "4993762c-ce5b-44db-9373-959bbc19ac88",
        humidityZ3TowerMidEnvironmentMid: "cf999266-3959-4cc2-a218-3a7e45b244ec",
        humidityZ3TowerMidEnvironmentUp: "d754da32-51b0-41fb-b5ca-e9a77c991508",
        humidityZ3TowerTopEnvironmentDown: "3c545c28-09e6-40d9-968b-75c8f92564ee",
        humidityZ3TowerTopEnvironmentMid: "6d53aec4-a9f6-4575-bfa3-e94f9174c12c",
        humidityZ3TowerTopEnvironmentUp: "043033cb-8aec-4cd0-8ed6-077e21ecad87",
        humidityZ4TowerMidEnvironmentDown: "7d62686f-b955-4542-a68f-4531b8e380a9",
        humidityZ4TowerMidEnvironmentMid: "e46e900c-00d4-4d4e-a1a4-dc0c2fe2be22",
        humidityZ4TowerMidEnvironmentUp: "21315ac6-9d0d-4b3c-9a11-3562c1e0254c",
        humidityZ4TowerTopEnvironmentDown: "eb14a35b-d46d-4d09-9ee4-f9b9f2880485",
        humidityZ4TowerTopEnvironmentMid: "87866948-3674-46ca-b70e-5e6a12d695e3",
        humidityZ4TowerTopEnvironmentUp: "8a9cebdb-1786-47f2-9f9e-86317cd06132",
        humidityZ5TowerMidEnvironmentDown: "b56c3ba1-f85d-47c3-8900-ef99eb766838",
        humidityZ5TowerMidEnvironmentMid: "3947a0d6-3873-449f-ae68-ccf7b9a353a9",
        humidityZ5TowerMidEnvironmentUp: "8603c4f1-9d24-4f6f-99f7-c80977a28a9e",
        humidityZ5TowerTopEnvironmentDown: "95322bb5-d441-4efc-a306-0343885a9056",
        humidityZ5TowerTopEnvironmentMid: "3f19ebed-f8a0-488a-b0ce-21bd639e4fe4",
        humidityZ5TowerTopEnvironmentUp: "72be3ac0-4b49-46d7-9d0b-cc4e384ccaee",
        humidityZ6TowerMidEnvironmentDown: "2372aa93-4e8a-4da0-a6a2-a770f1fbc99a",
        humidityZ6TowerMidEnvironmentMid: "a28e4ba8-e3dc-4262-9ccb-da8a80832708",
        humidityZ6TowerMidEnvironmentUp: "95b75401-e353-4f3d-94ad-892e0bfca9d9",
        humidityZ6TowerTopEnvironmentDown: "0f7a5716-23fc-4f23-862e-b705e9efd3ac",
        humidityZ6TowerTopEnvironmentMid: "950525c9-defe-49fc-a541-026f4b208ed3",
        humidityZ6TowerTopEnvironmentUp: "3f7acdb7-dd95-454b-9e3a-e7f136fcba70",
        humidityZ7TowerMidEnvironmentDown: "340161df-96e4-4480-b352-ea7d9c036a7b",
        humidityZ7TowerMidEnvironmentMid: "5d870b4f-bebf-448b-bce0-4b66c8f9df55",
        humidityZ7TowerMidEnvironmentUp: "047a3dad-ca1c-48a7-9dc7-9ce32553aa97",
        humidityZ7TowerTopEnvironmentDown: "a4a44370-0b07-4afc-a73e-3ceb4167d43b",
        humidityZ7TowerTopEnvironmentMid: "1d64c9bb-31a4-4d6c-9852-e5c67933eff9",
        humidityZ7TowerTopEnvironmentUp: "ebd0caf6-063a-4391-9a20-b177cf94ff31",
        humidityZ8TowerTopEnvironmentDown: "7794e86d-98aa-471d-b88c-4d9c945bad38",
        humidityZ8TowerTopEnvironmentMid: "f7633fec-d517-4abe-9f9d-04c41b748d87",
        humidityZ8TowerTopEnvironmentUp: "42da9d50-2a83-4014-b9ed-011a1713426a",
        humidityZ8TowerMidEnvironmentDown: "e70eeeee-bd6c-4cee-b700-5ebacc7d3eb8",
        humidityZ8TowerMidEnvironmentMid: "bd50b2df-4e9e-467a-b7b9-82886aadeb06",
        humidityZ8TowerMidEnvironmentUp: "466fc2dd-b15d-44bf-98c5-295a4e9d26e8",

        humidityRigidHingeEnvironmentJ41: "d34cd6da-e0d6-49f6-9604-f02364d972ae",
        humidityRigidHingeEnvironmentJ42: "5ae6b03a-7f17-425f-9846-2afbcecbac70",
        humidityRigidHingeEnvironmentJ43: "0e8d4d7a-d536-407d-891f-6b54e5b25452",
        humidityRigidHingeEnvironmentJ44: "6291142a-dc47-48f7-98e7-e7ce3ad75122",
        humidityRigidHingeEnvironmentJ31: "f8d73f17-5a52-464c-a870-139eaa852e52",
        humidityRigidHingeEnvironmentJ32: "423413c9-3655-438d-aebd-f956d6c9708f",
        humidityRigidHingeEnvironmentJ33: "1b7a48e6-9c4f-4841-9ed0-543b7b4b9004",
        humidityRigidHingeEnvironmentJ34: "38b0c73c-06a5-4755-923d-139542350cc4",
        humidityRigidHingeEnvironmentJ21: "30eb13a7-4d05-4f96-8de2-62c62faa2a34",
        humidityRigidHingeEnvironmentJ22: "d3409216-7aa8-42e8-a9e9-8e69c0275b49",
        humidityRigidHingeEnvironmentJ23: "9f938b37-3566-4971-9a7f-71cc48260271",
        humidityRigidHingeEnvironmentJ24: "375f25df-333f-4b80-bff5-9078df5c7c5b",
        humidityRigidHingeEnvironmentJ11: "0bfdc3a9-8759-4635-90db-bdda3a4cb320",
        humidityRigidHingeEnvironmentJ12: "b4c2ddf6-ccf1-44d3-a9e0-24360f158693",
        humidityRigidHingeEnvironmentJ13: "b0828718-8c03-4d16-a2b9-ce7f6895b0ad",
        humidityRigidHingeEnvironmentJ14: "c72da272-6f4b-446d-8b8a-1199c8b7b411",

        temperatureZ3TowerMidEnvironmentDown: "ba82c226-a535-434e-ae9c-34409e8d558b",
        temperatureZ3TowerMidEnvironmentMid: "fe442d7d-2230-4bde-8260-10bd69537f9e",
        temperatureZ3TowerMidEnvironmentUp: "06a3356a-928d-471f-8f92-cead40a94c7f",
        temperatureZ3TowerTopEnvironmentDown: "ada97a2e-e0b1-41e4-b334-368e025bc24d",
        temperatureZ3TowerTopEnvironmentMid: "158517c4-4369-42cb-865c-535332078b15",
        temperatureZ3TowerTopEnvironmentUp: "4a863572-f2e2-48ea-b36b-83d2924991f8",
        temperatureZ4TowerMidEnvironmentDown: "891738aa-0afa-407d-8f4f-d4b39811aaa0",
        temperatureZ4TowerMidEnvironmentMid: "1fb043a8-da20-45a7-ae59-c9e313e06b63",
        temperatureZ4TowerMidEnvironmentUp: "c1dbcd0d-915a-42e7-af63-46279d5a81c8",
        temperatureZ4TowerTopEnvironmentDown: "2069f59e-8cd0-4a0c-8e51-ba9ed157459b",
        temperatureZ4TowerTopEnvironmentMid: "8bee0858-c2fb-4be0-8908-cc643c7bf489",
        temperatureZ4TowerTopEnvironmentUp: "254c4e8e-161d-4b75-b1ce-139ec8554850",
        temperatureZ5TowerMidEnvironmentDown: "84f92ef0-dabb-453a-9f44-e28bcde1a8ca",
        temperatureZ5TowerMidEnvironmentMid: "907b3261-5937-4f19-8a44-e93e26180663",
        temperatureZ5TowerMidEnvironmentUp: "08868fba-559e-47c1-9b54-b86f374f2a1a",
        temperatureZ5TowerTopEnvironmentDown: "c0787000-9946-4419-9f85-126161a6a3e9",
        temperatureZ5TowerTopEnvironmentMid: "1e47bf1e-66a5-4e64-a69e-ea9ad153bf95",
        temperatureZ5TowerTopEnvironmentUp: "8b3b1a1e-3d81-44c0-9cb6-25eb698ddb29",
        temperatureZ6TowerMidEnvironmentDown: "f82662a8-7c5d-4f19-845a-97df9545d0eb",
        temperatureZ6TowerMidEnvironmentMid: "5bec5913-01e5-488e-8efe-b895fc9b2b19",
        temperatureZ6TowerMidEnvironmentUp: "77e76e64-a66f-45dd-ac52-54b84e3e95a5",
        temperatureZ6TowerTopEnvironmentDown: "ad6156d0-38f4-4b51-8c7f-b0267144047f",
        temperatureZ6TowerTopEnvironmentMid: "35aaf68f-9baf-48ef-a172-7e692f8fa383",
        temperatureZ6TowerTopEnvironmentUp: "65c59e85-bb5b-4fcc-9b15-c30ea8302081",
        temperatureZ7TowerMidEnvironmentDown: "5261ff8c-2941-49d8-be8a-987928f776f9",
        temperatureZ7TowerMidEnvironmentMid: "36a87b69-b60a-4393-9d8b-afdde517cc56",
        temperatureZ7TowerMidEnvironmentUp: "c69c9263-c0ff-48b2-9d0c-5096d5d585df",
        temperatureZ7TowerTopEnvironmentDown: "0017764b-c3e0-4456-930c-65b9ef0fde84",
        temperatureZ7TowerTopEnvironmentMid: "73ff750f-39fb-4caa-8abc-b6803e73b8bf",
        temperatureZ7TowerTopEnvironmentUp: "f4b06d47-1489-4885-87ba-178bf89afa62",
        temperatureZ8TowerTopEnvironmentDown: "e322c736-bd01-4796-a3f9-b6c8bb67e80f",
        temperatureZ8TowerTopEnvironmentMid: "f9e9ce6a-4cc2-42a5-9c70-28b92f4f03d3",
        temperatureZ8TowerTopEnvironmentUp: "d2fe859b-95cb-4b26-b1f3-e3591300d0eb",
        temperatureZ8TowerMidEnvironmentDown: "79500c40-f1ee-46ec-9ea7-f8f5b4bd49c2",
        temperatureZ8TowerMidEnvironmentMid: "51de2bbf-2512-4a98-8ad3-2906e469d4ee",
        temperatureZ8TowerMidEnvironmentUp: "3e76d4db-0783-4c31-8d41-1f6ec0403c74",

        temperatureRigidHingeEnvironmentJ41: "bebc2b5f-ff23-4405-9f0d-a3c53b323b52",
        temperatureRigidHingeEnvironmentJ42: "45b731b8-ae0d-45c5-91db-c1e7d9074adc",
        temperatureRigidHingeEnvironmentJ43: "988225b7-b9d6-435f-9f9b-57b218b929dd",
        temperatureRigidHingeEnvironmentJ44: "579746e4-4223-4120-a68e-9b9ce6e506dc",
        temperatureRigidHingeEnvironmentJ31: "d1d63189-783e-4e22-a080-6e248ec4d1b8",
        temperatureRigidHingeEnvironmentJ32: "7a0c698f-d768-4496-bfb7-835de2bad64e",
        temperatureRigidHingeEnvironmentJ33: "48b93060-6917-4710-8295-71311bb96b23",
        temperatureRigidHingeEnvironmentJ34: "49aac829-df0c-419a-a36e-580e78ba16cd",
        temperatureRigidHingeEnvironmentJ21: "f67bd43c-1519-4b8b-bdcd-5056ac74dc08",
        temperatureRigidHingeEnvironmentJ22: "76651444-6cb5-43af-9a7e-53d5186dd9ec",
        temperatureRigidHingeEnvironmentJ23: "9d2ae56e-9487-4134-a246-8313a23ad3aa",
        temperatureRigidHingeEnvironmentJ24: "545de84f-483d-4858-b511-792ac6a7b31f",
        temperatureRigidHingeEnvironmentJ11: "d4fe96dd-92b8-4997-a89f-577201d0b228",
        temperatureRigidHingeEnvironmentJ12: "e211b310-11df-4323-82f1-b81641bf6c30",
        temperatureRigidHingeEnvironmentJ13: "ed72c879-3b73-4544-b24a-e62f18c10020",
        temperatureRigidHingeEnvironmentJ14: "5fa4774a-82f3-46b5-91b0-53e6cb58c3c7",

        //running
        runningDehumidifierZ3TowerMid: "63874675-fb2b-4485-9e91-b111817ebef3",
        runningDehumidifierZ3TowerTop: "b73b269f-cad4-4d49-9286-68839dbc5699",
        runningDehumidifierZ4TowerMid: "d30b0118-a59b-46a0-afca-0ae7935f0b08",
        runningDehumidifierZ4TowerTop: "b6e90ebb-61d9-474e-91a5-acf423f8f6a1",
        runningDehumidifierZ5TowerMid: "57d5ac79-d2fa-4de2-a9a4-8e22421eb78a",
        runningDehumidifierZ5TowerTop: "330eb75c-0a86-4f03-b274-7a6c72c43aca",
        runningDehumidifierZ6TowerMid: "66f014c4-cb84-4521-91e3-e494793479d7",
        runningDehumidifierZ6TowerTop: "6d63a452-62e5-463c-b0ca-f185d2b67a08",
        runningDehumidifierZ7TowerMid: "037cdc71-ccc7-4558-865a-6b1eb90b4810",
        runningDehumidifierZ7TowerTop: "32bea74c-8b33-46cc-b12a-1aa0aae71ddd",
        runningDehumidifierZ8TowerMid: "f22221a5-971e-40e5-a6e1-43b05f450e28",
        runningDehumidifierZ8TowerTop: "0de9399a-b07e-4809-8f14-9d6053db762f",

        runningDehumidifierRigidHingeJ3LJ4: "d4a811c8-bbda-4ecc-b91f-fd7ca881e0c4",
        runningDehumidifierRigidHingeJ3LJ3: "aac1cede-372d-4f47-8d32-10acafeccb38",
        runningDehumidifierRigidHingeJ3RJ2: "e2e6a8cd-2761-4338-837b-b7a3fb90d778",
        runningDehumidifierRigidHingeJ3RJ1: "f92dbd41-108f-4305-9178-0142f5eff2d0",

        //malfunction
        malfunctionDehumidifierZ3TowerMid: "b76e3d1b-17b3-48a1-b5bf-54bba5ed67c1",
        malfunctionDehumidifierZ3TowerTop: "aa67031c-00ab-4dbe-8783-6a2ab43e3744",
        malfunctionDehumidifierZ4TowerMid: "4f36f298-0536-413a-b97e-62866346085f",
        malfunctionDehumidifierZ4TowerTop: "2feedca5-679b-43d5-beb3-1919dee9c69d",
        malfunctionDehumidifierZ5TowerMid: "fe4f9046-7fa1-4b81-9089-bb73909e37b6",
        malfunctionDehumidifierZ5TowerTop: "77c09a14-e132-49d2-b652-0617b7dd4631",
        malfunctionDehumidifierZ6TowerMid: "915f58db-c862-47b7-9c83-ed319f86d3a0",
        malfunctionDehumidifierZ6TowerTop: "a9ca5c3e-9bab-437c-a423-c07dd4496909",
        malfunctionDehumidifierZ7TowerMid: "7a324484-b71e-46c5-bf8f-f34a1ad40c75",
        malfunctionDehumidifierZ7TowerTop: "60758cfc-d499-4fe7-897e-acca0d659fcc",
        malfunctionDehumidifierZ8TowerMid: "f2debb6a-181c-49f2-a942-8c3c9fa12595",
        malfunctionDehumidifierZ8TowerTop: "31d41712-dec8-4b4c-879d-547cd16750fb",

        malfunctionDehumidifierRigidHingeJ3LJ4: "510e0cd1-2bdd-4424-b6ae-050b9f1f4620",
        malfunctionDehumidifierRigidHingeJ3LJ3: "722d94bd-e059-46f1-8c4b-0e73552436a4",
        malfunctionDehumidifierRigidHingeJ3RJ2: "417c5e71-2153-4758-b066-5333e7f55412",
        malfunctionDehumidifierRigidHingeJ3RJ1: "56abfcdc-f086-450c-8d97-79098b16556c",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxDehumidifierZ3TowerMid: "91ae8484-fa72-4536-bbcf-227485d00984",
        humidityAllowedMaxDehumidifierZ3TowerTop: "a8355f4b-f4f3-4175-bb43-48b6406edf37",
        humidityAllowedMaxDehumidifierZ4TowerMid: "5d116a33-9429-4ea6-9c12-70ca1a3615c9",
        humidityAllowedMaxDehumidifierZ4TowerTop: "1a50053a-6642-4b2f-8485-448ad89d99d0",
        humidityAllowedMaxDehumidifierZ5TowerMid: "e63f2494-2009-431b-b169-d56c178fcc02",
        humidityAllowedMaxDehumidifierZ5TowerTop: "7c6e3109-18ff-4c72-8a86-1bf25ec57260",
        humidityAllowedMaxDehumidifierZ6TowerMid: "7d85ad73-ed97-488f-a041-2a5a6a6be417",
        humidityAllowedMaxDehumidifierZ6TowerTop: "4404eb6b-a447-45cc-8739-9dd6d7b5c1c1",
        humidityAllowedMaxDehumidifierZ7TowerMid: "b1831c64-d258-498a-9323-4fba75f44760",
        humidityAllowedMaxDehumidifierZ7TowerTop: "8635be2d-8dbb-4407-b101-3fc48e399a6c",
        humidityAllowedMaxDehumidifierZ8TowerTop: "6a1c4917-87b6-46fa-8112-d81e787c680a",
        humidityAllowedMaxDehumidifierZ8TowerMid: "ad9ed67f-1dbf-4656-9fdd-e0f8ab65bd9f",

        humidityAllowedMaxZ3TowerMidEnvironmentDown: "4993762c-ce5b-44db-9373-959bbc19ac88",
        humidityAllowedMaxZ3TowerMidEnvironmentMid: "cf999266-3959-4cc2-a218-3a7e45b244ec",
        humidityAllowedMaxZ3TowerMidEnvironmentUp: "d754da32-51b0-41fb-b5ca-e9a77c991508",
        humidityAllowedMaxZ3TowerTopEnvironmentDown: "3c545c28-09e6-40d9-968b-75c8f92564ee",
        humidityAllowedMaxZ3TowerTopEnvironmentMid: "6d53aec4-a9f6-4575-bfa3-e94f9174c12c",
        humidityAllowedMaxZ3TowerTopEnvironmentUp: "043033cb-8aec-4cd0-8ed6-077e21ecad87",
        humidityAllowedMaxZ4TowerMidEnvironmentDown: "7d62686f-b955-4542-a68f-4531b8e380a9",
        humidityAllowedMaxZ4TowerMidEnvironmentMid: "e46e900c-00d4-4d4e-a1a4-dc0c2fe2be22",
        humidityAllowedMaxZ4TowerMidEnvironmentUp: "21315ac6-9d0d-4b3c-9a11-3562c1e0254c",
        humidityAllowedMaxZ4TowerTopEnvironmentDown: "eb14a35b-d46d-4d09-9ee4-f9b9f2880485",
        humidityAllowedMaxZ4TowerTopEnvironmentMid: "87866948-3674-46ca-b70e-5e6a12d695e3",
        humidityAllowedMaxZ4TowerTopEnvironmentUp: "8a9cebdb-1786-47f2-9f9e-86317cd06132",
        humidityAllowedMaxZ5TowerMidEnvironmentDown: "b56c3ba1-f85d-47c3-8900-ef99eb766838",
        humidityAllowedMaxZ5TowerMidEnvironmentMid: "3947a0d6-3873-449f-ae68-ccf7b9a353a9",
        humidityAllowedMaxZ5TowerMidEnvironmentUp: "8603c4f1-9d24-4f6f-99f7-c80977a28a9e",
        humidityAllowedMaxZ5TowerTopEnvironmentDown: "95322bb5-d441-4efc-a306-0343885a9056",
        humidityAllowedMaxZ5TowerTopEnvironmentMid: "3f19ebed-f8a0-488a-b0ce-21bd639e4fe4",
        humidityAllowedMaxZ5TowerTopEnvironmentUp: "72be3ac0-4b49-46d7-9d0b-cc4e384ccaee",
        humidityAllowedMaxZ6TowerMidEnvironmentDown: "2372aa93-4e8a-4da0-a6a2-a770f1fbc99a",
        humidityAllowedMaxZ6TowerMidEnvironmentMid: "a28e4ba8-e3dc-4262-9ccb-da8a80832708",
        humidityAllowedMaxZ6TowerMidEnvironmentUp: "95b75401-e353-4f3d-94ad-892e0bfca9d9",
        humidityAllowedMaxZ6TowerTopEnvironmentDown: "0f7a5716-23fc-4f23-862e-b705e9efd3ac",
        humidityAllowedMaxZ6TowerTopEnvironmentMid: "950525c9-defe-49fc-a541-026f4b208ed3",
        humidityAllowedMaxZ6TowerTopEnvironmentUp: "3f7acdb7-dd95-454b-9e3a-e7f136fcba70",
        humidityAllowedMaxZ7TowerMidEnvironmentDown: "340161df-96e4-4480-b352-ea7d9c036a7b",
        humidityAllowedMaxZ7TowerMidEnvironmentMid: "5d870b4f-bebf-448b-bce0-4b66c8f9df55",
        humidityAllowedMaxZ7TowerMidEnvironmentUp: "047a3dad-ca1c-48a7-9dc7-9ce32553aa97",
        humidityAllowedMaxZ7TowerTopEnvironmentDown: "a4a44370-0b07-4afc-a73e-3ceb4167d43b",
        humidityAllowedMaxZ7TowerTopEnvironmentMid: "1d64c9bb-31a4-4d6c-9852-e5c67933eff9",
        humidityAllowedMaxZ7TowerTopEnvironmentUp: "ebd0caf6-063a-4391-9a20-b177cf94ff31",
        humidityAllowedMaxZ8TowerTopEnvironmentDown: "7794e86d-98aa-471d-b88c-4d9c945bad38",
        humidityAllowedMaxZ8TowerTopEnvironmentMid: "f7633fec-d517-4abe-9f9d-04c41b748d87",
        humidityAllowedMaxZ8TowerTopEnvironmentUp: "42da9d50-2a83-4014-b9ed-011a1713426a",
        humidityAllowedMaxZ8TowerMidEnvironmentDown: "e70eeeee-bd6c-4cee-b700-5ebacc7d3eb8",
        humidityAllowedMaxZ8TowerMidEnvironmentMid: "bd50b2df-4e9e-467a-b7b9-82886aadeb06",
        humidityAllowedMaxZ8TowerMidEnvironmentUp: "466fc2dd-b15d-44bf-98c5-295a4e9d26e8",

        humidityAllowedMaxRigidHingeEnvironmentJ41: "d34cd6da-e0d6-49f6-9604-f02364d972ae",
        humidityAllowedMaxRigidHingeEnvironmentJ42: "5ae6b03a-7f17-425f-9846-2afbcecbac70",
        humidityAllowedMaxRigidHingeEnvironmentJ43: "0e8d4d7a-d536-407d-891f-6b54e5b25452",
        humidityAllowedMaxRigidHingeEnvironmentJ44: "6291142a-dc47-48f7-98e7-e7ce3ad75122",
        humidityAllowedMaxRigidHingeEnvironmentJ31: "f8d73f17-5a52-464c-a870-139eaa852e52",
        humidityAllowedMaxRigidHingeEnvironmentJ32: "423413c9-3655-438d-aebd-f956d6c9708f",
        humidityAllowedMaxRigidHingeEnvironmentJ33: "1b7a48e6-9c4f-4841-9ed0-543b7b4b9004",
        humidityAllowedMaxRigidHingeEnvironmentJ34: "38b0c73c-06a5-4755-923d-139542350cc4",
        humidityAllowedMaxRigidHingeEnvironmentJ21: "30eb13a7-4d05-4f96-8de2-62c62faa2a34",
        humidityAllowedMaxRigidHingeEnvironmentJ22: "d3409216-7aa8-42e8-a9e9-8e69c0275b49",
        humidityAllowedMaxRigidHingeEnvironmentJ23: "9f938b37-3566-4971-9a7f-71cc48260271",
        humidityAllowedMaxRigidHingeEnvironmentJ24: "375f25df-333f-4b80-bff5-9078df5c7c5b",
        humidityAllowedMaxRigidHingeEnvironmentJ11: "0bfdc3a9-8759-4635-90db-bdda3a4cb320",
        humidityAllowedMaxRigidHingeEnvironmentJ12: "b4c2ddf6-ccf1-44d3-a9e0-24360f158693",
        humidityAllowedMaxRigidHingeEnvironmentJ13: "b0828718-8c03-4d16-a2b9-ce7f6895b0ad",
        humidityAllowedMaxRigidHingeEnvironmentJ14: "c72da272-6f4b-446d-8b8a-1199c8b7b411",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidityDehumidifierZ3TowerTop: "errorZ3TowerTop",
        humidityDehumidifierZ3TowerMid: "errorZ3TowerMid",
        humidityDehumidifierZ4TowerTop: "errorZ4TowerTop",
        humidityDehumidifierZ4TowerMid: "errorZ4TowerMid",
        humidityDehumidifierZ5TowerTop: "errorZ5TowerTop",
        humidityDehumidifierZ5TowerMid: "errorZ5TowerMid",
        humidityDehumidifierZ6TowerTop: "errorZ6TowerTop",
        humidityDehumidifierZ6TowerMid: "errorZ6TowerMid",
        humidityDehumidifierZ7TowerTop: "errorZ7TowerTop",
        humidityDehumidifierZ7TowerMid: "errorZ7TowerMid",
        humidityDehumidifierZ8TowerTop: "errorZ8TowerTop",
        humidityDehumidifierZ8TowerMid: "errorZ8TowerMid",

        temperatureDehumidifierZ3TowerTop: "errorZ3TowerTop",
        temperatureDehumidifierZ3TowerMid: "errorZ3TowerMid",
        temperatureDehumidifierZ4TowerTop: "errorZ4TowerTop",
        temperatureDehumidifierZ4TowerMid: "errorZ4TowerMid",
        temperatureDehumidifierZ5TowerTop: "errorZ5TowerTop",
        temperatureDehumidifierZ5TowerMid: "errorZ5TowerMid",
        temperatureDehumidifierZ6TowerTop: "errorZ6TowerTop",
        temperatureDehumidifierZ6TowerMid: "errorZ6TowerMid",
        temperatureDehumidifierZ7TowerTop: "errorZ7TowerTop",
        temperatureDehumidifierZ7TowerMid: "errorZ7TowerMid",
        temperatureDehumidifierZ8TowerTop: "errorZ8TowerTop",
        temperatureDehumidifierZ8TowerMid: "errorZ8TowerMid",

        humidityZ3TowerTopEnvironmentUp: "errorZ3TowerTop",
        humidityZ3TowerTopEnvironmentMid: "errorZ3TowerTop",
        humidityZ3TowerTopEnvironmentDown: "errorZ3TowerTop",
        humidityZ3TowerMidEnvironmentUp: "errorZ3TowerMid",
        humidityZ3TowerMidEnvironmentMid: "errorZ3TowerMid",
        humidityZ3TowerMidEnvironmentDown: "errorZ3TowerMid",
        humidityZ4TowerTopEnvironmentUp: "errorZ4TowerTop",
        humidityZ4TowerTopEnvironmentMid: "errorZ4TowerTop",
        humidityZ4TowerTopEnvironmentDown: "errorZ4TowerTop",
        humidityZ4TowerMidEnvironmentUp: "errorZ4TowerMid",
        humidityZ4TowerMidEnvironmentMid: "errorZ4TowerMid",
        humidityZ4TowerMidEnvironmentDown: "errorZ4TowerMid",
        humidityZ5TowerTopEnvironmentUp: "errorZ5TowerTop",
        humidityZ5TowerTopEnvironmentMid: "errorZ5TowerTop",
        humidityZ5TowerTopEnvironmentDown: "errorZ5TowerTop",
        humidityZ5TowerMidEnvironmentUp: "errorZ5TowerMid",
        humidityZ5TowerMidEnvironmentMid: "errorZ5TowerMid",
        humidityZ5TowerMidEnvironmentDown: "errorZ5TowerMid",
        humidityZ6TowerTopEnvironmentUp: "errorZ6TowerTop",
        humidityZ6TowerTopEnvironmentMid: "errorZ6TowerTop",
        humidityZ6TowerTopEnvironmentDown: "errorZ6TowerTop",
        humidityZ6TowerMidEnvironmentUp: "errorZ6TowerMid",
        humidityZ6TowerMidEnvironmentMid: "errorZ6TowerMid",
        humidityZ6TowerMidEnvironmentDown: "errorZ6TowerMid",
        humidityZ7TowerTopEnvironmentUp: "errorZ7TowerTop",
        humidityZ7TowerTopEnvironmentMid: "errorZ7TowerTop",
        humidityZ7TowerTopEnvironmentDown: "errorZ7TowerTop",
        humidityZ7TowerMidEnvironmentUp: "errorZ7TowerMid",
        humidityZ7TowerMidEnvironmentMid: "errorZ7TowerMid",
        humidityZ7TowerMidEnvironmentDown: "errorZ7TowerMid",
        humidityZ8TowerTopEnvironmentUp: "errorZ8TowerTop",
        humidityZ8TowerTopEnvironmentMid: "errorZ8TowerTop",
        humidityZ8TowerTopEnvironmentDown: "errorZ8TowerTop",
        humidityZ8TowerMidEnvironmentUp: "errorZ8TowerMid",
        humidityZ8TowerMidEnvironmentMid: "errorZ8TowerMid",
        humidityZ8TowerMidEnvironmentDown: "errorZ8TowerMid",

        humidityRigidHingeEnvironmentJ11: "errorRigidHingeJ3RJ1",
        humidityRigidHingeEnvironmentJ12: "errorRigidHingeJ3RJ1",
        humidityRigidHingeEnvironmentJ13: "errorRigidHingeJ3RJ1",
        humidityRigidHingeEnvironmentJ14: "errorRigidHingeJ3RJ1",
        humidityRigidHingeEnvironmentJ21: "errorRigidHingeJ3RJ2",
        humidityRigidHingeEnvironmentJ22: "errorRigidHingeJ3RJ2",
        humidityRigidHingeEnvironmentJ23: "errorRigidHingeJ3RJ2",
        humidityRigidHingeEnvironmentJ24: "errorRigidHingeJ3RJ2",
        humidityRigidHingeEnvironmentJ31: "errorRigidHingeJ3LJ3",
        humidityRigidHingeEnvironmentJ32: "errorRigidHingeJ3LJ3",
        humidityRigidHingeEnvironmentJ33: "errorRigidHingeJ3LJ3",
        humidityRigidHingeEnvironmentJ34: "errorRigidHingeJ3LJ3",
        humidityRigidHingeEnvironmentJ41: "errorRigidHingeJ3LJ4",
        humidityRigidHingeEnvironmentJ42: "errorRigidHingeJ3LJ4",
        humidityRigidHingeEnvironmentJ43: "errorRigidHingeJ3LJ4",
        humidityRigidHingeEnvironmentJ44: "errorRigidHingeJ3LJ4",

        temperaturerZ3TowerTopEnvironmentUp: "errorZ3TowerTop",
        temperaturerZ3TowerTopEnvironmentMid: "errorZ3TowerTop",
        temperaturerZ3TowerTopEnvironmentDown: "errorZ3TowerTop",
        temperaturerZ3TowerMidEnvironmentUp: "errorZ3TowerMid",
        temperaturerZ3TowerMidEnvironmentMid: "errorZ3TowerMid",
        temperaturerZ3TowerMidEnvironmentDown: "errorZ3TowerMid",
        temperaturerZ4TowerTopEnvironmentUp: "errorZ4TowerTop",
        temperaturerZ4TowerTopEnvironmentMid: "errorZ4TowerTop",
        temperaturerZ4TowerTopEnvironmentDown: "errorZ4TowerTop",
        temperaturerZ4TowerMidEnvironmentUp: "errorZ4TowerMid",
        temperaturerZ4TowerMidEnvironmentMid: "errorZ4TowerMid",
        temperaturerZ4TowerMidEnvironmentDown: "errorZ4TowerMid",
        temperaturerZ5TowerTopEnvironmentUp: "errorZ5TowerTop",
        temperaturerZ5TowerTopEnvironmentMid: "errorZ5TowerTop",
        temperaturerZ5TowerTopEnvironmentDown: "errorZ5TowerTop",
        temperaturerZ5TowerMidEnvironmentUp: "errorZ5TowerMid",
        temperaturerZ5TowerMidEnvironmentMid: "errorZ5TowerMid",
        temperaturerZ5TowerMidEnvironmentDown: "errorZ5TowerMid",
        temperaturerZ6TowerTopEnvironmentUp: "errorZ6TowerTop",
        temperaturerZ6TowerTopEnvironmentMid: "errorZ6TowerTop",
        temperaturerZ6TowerTopEnvironmentDown: "errorZ6TowerTop",
        temperaturerZ6TowerMidEnvironmentUp: "errorZ6TowerMid",
        temperaturerZ6TowerMidEnvironmentMid: "errorZ6TowerMid",
        temperaturerZ6TowerMidEnvironmentDown: "errorZ6TowerMid",
        temperaturerZ7TowerTopEnvironmentUp: "errorZ7TowerTop",
        temperaturerZ7TowerTopEnvironmentMid: "errorZ7TowerTop",
        temperaturerZ7TowerTopEnvironmentDown: "errorZ7TowerTop",
        temperaturerZ7TowerMidEnvironmentUp: "errorZ7TowerMid",
        temperaturerZ7TowerMidEnvironmentMid: "errorZ7TowerMid",
        temperaturerZ7TowerMidEnvironmentDown: "errorZ7TowerMid",
        temperaturerZ8TowerTopEnvironmentUp: "errorZ8TowerTop",
        temperaturerZ8TowerTopEnvironmentMid: "errorZ8TowerTop",
        temperaturerZ8TowerTopEnvironmentDown: "errorZ8TowerTop",
        temperaturerZ8TowerMidEnvironmentUp: "errorZ8TowerMid",
        temperaturerZ8TowerMidEnvironmentMid: "errorZ8TowerMid",
        temperaturerZ8TowerMidEnvironmentDown: "errorZ8TowerMid",

        temperaturerRigidHingeEnvironmentJ11: "errorRigidHingeJ3RJ1",
        temperaturerRigidHingeEnvironmentJ12: "errorRigidHingeJ3RJ1",
        temperaturerRigidHingeEnvironmentJ13: "errorRigidHingeJ3RJ1",
        temperaturerRigidHingeEnvironmentJ14: "errorRigidHingeJ3RJ1",
        temperaturerRigidHingeEnvironmentJ21: "errorRigidHingeJ3RJ2",
        temperaturerRigidHingeEnvironmentJ22: "errorRigidHingeJ3RJ2",
        temperaturerRigidHingeEnvironmentJ23: "errorRigidHingeJ3RJ2",
        temperaturerRigidHingeEnvironmentJ24: "errorRigidHingeJ3RJ2",
        temperaturerRigidHingeEnvironmentJ31: "errorRigidHingeJ3LJ3",
        temperaturerRigidHingeEnvironmentJ32: "errorRigidHingeJ3LJ3",
        temperaturerRigidHingeEnvironmentJ33: "errorRigidHingeJ3LJ3",
        temperaturerRigidHingeEnvironmentJ34: "errorRigidHingeJ3LJ3",
        temperaturerRigidHingeEnvironmentJ41: "errorRigidHingeJ3LJ4",
        temperaturerRigidHingeEnvironmentJ42: "errorRigidHingeJ3LJ4",
        temperaturerRigidHingeEnvironmentJ43: "errorRigidHingeJ3LJ4",
        temperaturerRigidHingeEnvironmentJ44: "errorRigidHingeJ3LJ4",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierZ3TowerTop: "errorZ3TowerTop",
        malfunctionDehumidifierZ3TowerMid: "errorZ3TowerMid",
        malfunctionDehumidifierZ4TowerTop: "errorZ4TowerTop",
        malfunctionDehumidifierZ4TowerMid: "errorZ4TowerMid",
        malfunctionDehumidifierZ5TowerTop: "errorZ5TowerTop",
        malfunctionDehumidifierZ5TowerMid: "errorZ5TowerMid",
        malfunctionDehumidifierZ6TowerTop: "errorZ6TowerTop",
        malfunctionDehumidifierZ6TowerMid: "errorZ6TowerMid",
        malfunctionDehumidifierZ7TowerTop: "errorZ7TowerTop",
        malfunctionDehumidifierZ7TowerMid: "errorZ7TowerMid",
        malfunctionDehumidifierZ8TowerTop: "errorZ8TowerTop",
        malfunctionDehumidifierZ8TowerMid: "errorZ8TowerMid",

        malfunctionDehumidifierRigidHingeJ3RJ1: "errorRigidHingeJ3RJ1",
        malfunctionDehumidifierRigidHingeJ3RJ2: "errorRigidHingeJ3RJ2",
        malfunctionDehumidifierRigidHingeJ3LJ3: "errorRigidHingeJ3LJ3",
        malfunctionDehumidifierRigidHingeJ3LJ4: "errorRigidHingeJ3LJ4",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityDehumidifierZ3TowerTop: "humidityTooltipErrorDehumidifierZ3TowerTop",
        humidityDehumidifierZ3TowerMid: "humidityTooltipErrorDehumidifierZ3TowerMid",
        humidityDehumidifierZ4TowerTop: "humidityTooltipErrorDehumidifierZ4TowerTop",
        humidityDehumidifierZ4TowerMid: "humidityTooltipErrorDehumidifierZ4TowerMid",
        humidityDehumidifierZ5TowerTop: "humidityTooltipErrorDehumidifierZ5TowerTop",
        humidityDehumidifierZ5TowerMid: "humidityTooltipErrorDehumidifierZ5TowerMid",
        humidityDehumidifierZ6TowerTop: "humidityTooltipErrorDehumidifierZ6TowerTop",
        humidityDehumidifierZ6TowerMid: "humidityTooltipErrorDehumidifierZ6TowerMid",
        humidityDehumidifierZ7TowerTop: "humidityTooltipErrorDehumidifierZ7TowerTop",
        humidityDehumidifierZ7TowerMid: "humidityTooltipErrorDehumidifierZ7TowerMid",
        humidityDehumidifierZ8TowerTop: "humidityTooltipErrorDehumidifierZ8TowerTop",
        humidityDehumidifierZ8TowerMid: "humidityTooltipErrorDehumidifierZ8TowerMid",

        humidityZ3TowerTopEnvironmentUp: "humidityTooltipErrorZ3TowerTopEnvironmentUp",
        humidityZ3TowerTopEnvironmentMid: "humidityTooltipErrorZ3TowerTopEnvironmentMid",
        humidityZ3TowerTopEnvironmentDown: "humidityTooltipErrorZ3TowerTopEnvironmentDown",
        humidityZ3TowerMidEnvironmentUp: "humidityTooltipErrorZ3TowerMidEnvironmentUp",
        humidityZ3TowerMidEnvironmentMid: "humidityTooltipErrorZ3TowerMidEnvironmentMid",
        humidityZ3TowerMidEnvironmentDown: "humidityTooltipErrorZ3TowerMidEnvironmentDown",
        humidityZ4TowerTopEnvironmentUp: "humidityTooltipErrorZ4TowerTopEnvironmentUp",
        humidityZ4TowerTopEnvironmentMid: "humidityTooltipErrorZ4TowerTopEnvironmentMid",
        humidityZ4TowerTopEnvironmentDown: "humidityTooltipErrorZ4TowerTopEnvironmentDown",
        humidityZ4TowerMidEnvironmentUp: "humidityTooltipErrorZ4TowerMidEnvironmentUp",
        humidityZ4TowerMidEnvironmentMid: "humidityTooltipErrorZ4TowerMidEnvironmentMid",
        humidityZ4TowerMidEnvironmentDown: "humidityTooltipErrorZ4TowerMidEnvironmentDown",
        humidityZ5TowerTopEnvironmentUp: "humidityTooltipErrorZ5TowerTopEnvironmentUp",
        humidityZ5TowerTopEnvironmentMid: "humidityTooltipErrorZ5TowerTopEnvironmentMid",
        humidityZ5TowerTopEnvironmentDown: "humidityTooltipErrorZ5TowerTopEnvironmentDown",
        humidityZ5TowerMidEnvironmentUp: "humidityTooltipErrorZ5TowerMidEnvironmentUp",
        humidityZ5TowerMidEnvironmentMid: "humidityTooltipErrorZ5TowerMidEnvironmentMid",
        humidityZ5TowerMidEnvironmentDown: "humidityTooltipErrorZ5TowerMidEnvironmentDown",
        humidityZ6TowerTopEnvironmentUp: "humidityTooltipErrorZ6TowerTopEnvironmentUp",
        humidityZ6TowerTopEnvironmentMid: "humidityTooltipErrorZ6TowerTopEnvironmentMid",
        humidityZ6TowerTopEnvironmentDown: "humidityTooltipErrorZ6TowerTopEnvironmentDown",
        humidityZ6TowerMidEnvironmentUp: "humidityTooltipErrorZ6TowerMidEnvironmentUp",
        humidityZ6TowerMidEnvironmentMid: "humidityTooltipErrorZ6TowerMidEnvironmentMid",
        humidityZ6TowerMidEnvironmentDown: "humidityTooltipErrorZ6TowerMidEnvironmentDown",
        humidityZ7TowerTopEnvironmentUp: "humidityTooltipErrorZ7TowerTopEnvironmentUp",
        humidityZ7TowerTopEnvironmentMid: "humidityTooltipErrorZ7TowerTopEnvironmentMid",
        humidityZ7TowerTopEnvironmentDown: "humidityTooltipErrorZ7TowerTopEnvironmentDown",
        humidityZ7TowerMidEnvironmentUp: "humidityTooltipErrorZ7TowerMidEnvironmentUp",
        humidityZ7TowerMidEnvironmentMid: "humidityTooltipErrorZ7TowerMidEnvironmentMid",
        humidityZ7TowerMidEnvironmentDown: "humidityTooltipErrorZ7TowerMidEnvironmentDown",
        humidityZ8TowerTopEnvironmentUp: "humidityTooltipErrorZ8TowerTopEnvironmentUp",
        humidityZ8TowerTopEnvironmentMid: "humidityTooltipErrorZ8TowerTopEnvironmentMid",
        humidityZ8TowerTopEnvironmentDown: "humidityTooltipErrorZ8TowerTopEnvironmentDown",
        humidityZ8TowerMidEnvironmentUp: "humidityTooltipErrorZ8TowerMidEnvironmentUp",
        humidityZ8TowerMidEnvironmentMid: "humidityTooltipErrorZ8TowerMidEnvironmentMid",
        humidityZ8TowerMidEnvironmentDown: "humidityTooltipErrorZ8TowerMidEnvironmentDown",

        humidityRigidHingeEnvironmentJ11: "humidityTooltipErrorRigidHingeEnvironmentJ11",
        humidityRigidHingeEnvironmentJ12: "humidityTooltipErrorRigidHingeEnvironmentJ12",
        humidityRigidHingeEnvironmentJ13: "humidityTooltipErrorRigidHingeEnvironmentJ13",
        humidityRigidHingeEnvironmentJ14: "humidityTooltipErrorRigidHingeEnvironmentJ14",
        humidityRigidHingeEnvironmentJ21: "humidityTooltipErrorRigidHingeEnvironmentJ21",
        humidityRigidHingeEnvironmentJ22: "humidityTooltipErrorRigidHingeEnvironmentJ22",
        humidityRigidHingeEnvironmentJ23: "humidityTooltipErrorRigidHingeEnvironmentJ23",
        humidityRigidHingeEnvironmentJ24: "humidityTooltipErrorRigidHingeEnvironmentJ24",
        humidityRigidHingeEnvironmentJ31: "humidityTooltipErrorRigidHingeEnvironmentJ31",
        humidityRigidHingeEnvironmentJ32: "humidityTooltipErrorRigidHingeEnvironmentJ32",
        humidityRigidHingeEnvironmentJ33: "humidityTooltipErrorRigidHingeEnvironmentJ33",
        humidityRigidHingeEnvironmentJ34: "humidityTooltipErrorRigidHingeEnvironmentJ34",
        humidityRigidHingeEnvironmentJ41: "humidityTooltipErrorRigidHingeEnvironmentJ41",
        humidityRigidHingeEnvironmentJ42: "humidityTooltipErrorRigidHingeEnvironmentJ42",
        humidityRigidHingeEnvironmentJ43: "humidityTooltipErrorRigidHingeEnvironmentJ43",
        humidityRigidHingeEnvironmentJ44: "humidityTooltipErrorRigidHingeEnvironmentJ44",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierZ3TowerTop: "runningClassZ3TowerTop",
        runningDehumidifierZ3TowerMid: "runningClassZ3TowerMid",
        runningDehumidifierZ4TowerTop: "runningClassZ4TowerTop",
        runningDehumidifierZ4TowerMid: "runningClassZ4TowerMid",
        runningDehumidifierZ5TowerTop: "runningClassZ5TowerTop",
        runningDehumidifierZ5TowerMid: "runningClassZ5TowerMid",
        runningDehumidifierZ6TowerTop: "runningClassZ6TowerTop",
        runningDehumidifierZ6TowerMid: "runningClassZ6TowerMid",
        runningDehumidifierZ7TowerTop: "runningClassZ7TowerTop",
        runningDehumidifierZ7TowerMid: "runningClassZ7TowerMid",
        runningDehumidifierZ8TowerTop: "runningClassZ8TowerTop",
        runningDehumidifierZ8TowerMid: "runningClassZ8TowerMid",

        runningDehumidifierRigidHingeJ3RJ1: "runningClassRigidHingeJ3RJ1",
        runningDehumidifierRigidHingeJ3RJ2: "runningClassRigidHingeJ3RJ2",
        runningDehumidifierRigidHingeJ3LJ3: "runningClassRigidHingeJ3LJ3",
        runningDehumidifierRigidHingeJ3LJ4: "runningClassRigidHingeJ3LJ4",
      },

      //station id list
      stationIdList: [
        "858b1dcd-950e-4509-a7e7-6cc6a2f803c2",
        "a55f9fb5-e7fa-491d-b71d-46e18128622b",
        "cafaff51-1384-4d5b-adf2-9794e9ae14ac",
        "ecb57cb1-3aeb-4206-bdfb-8924c69fa481",
        "9c96ed22-ca04-419d-bda3-ce161be52848",
        "e40720d4-4494-47db-8031-521973859c24",
        "7acd13cd-3875-46a9-8db8-3740a1bb484e",
        "22e61165-6b8c-48db-ba28-c9716a0ee8de",
        "a55c160d-2fe2-4ddd-80c4-734705b31b3a",
        "4cdcf523-3b6f-4307-a91c-5eda40fbda3d",
        "745d7a0b-eafc-4362-af68-f4ee3c44cd65",
        "5f48149c-1e46-4bc1-953b-57a616340425",
        "d2462ab0-70e3-43c3-8c6f-c066b6213b90",
        "817c9059-31db-4bb2-b158-acbc92e3132c",
        "72a340b4-7faa-47a4-9d8e-6adb815682c1",
        "3392158f-ff2f-4245-ab0d-68e015eb2a0f",
      ],

      stationNameStationIdDict: {
        "stationT2": "858b1dcd-950e-4509-a7e7-6cc6a2f803c2",
        "stationT1": "a55f9fb5-e7fa-491d-b71d-46e18128622b",
        "stationT9": "cafaff51-1384-4d5b-adf2-9794e9ae14ac",
        "stationT11": "ecb57cb1-3aeb-4206-bdfb-8924c69fa481",
        "stationT3": "9c96ed22-ca04-419d-bda3-ce161be52848",
        "stationT6": "e40720d4-4494-47db-8031-521973859c24",
        "stationT7": "7acd13cd-3875-46a9-8db8-3740a1bb484e",
        "stationT4": "22e61165-6b8c-48db-ba28-c9716a0ee8de",
        "stationT10": "a55c160d-2fe2-4ddd-80c4-734705b31b3a",
        "stationT5": "4cdcf523-3b6f-4307-a91c-5eda40fbda3d",
        "stationT8": "745d7a0b-eafc-4362-af68-f4ee3c44cd65",
        "stationT12": "5f48149c-1e46-4bc1-953b-57a616340425",
        "stationJ3": "d2462ab0-70e3-43c3-8c6f-c066b6213b90",
        "stationJ1": "817c9059-31db-4bb2-b158-acbc92e3132c",
        "stationJ2": "72a340b4-7faa-47a4-9d8e-6adb815682c1",
        "stationJ4": "3392158f-ff2f-4245-ab0d-68e015eb2a0f",
      },

      stationNameLoadingDict: {
        "stationT2": false,
        "stationT1": false,
        "stationT9": false,
        "stationT11": false,
        "stationT3": false,
        "stationT6": false,
        "stationT7": false,
        "stationT4": false,
        "stationT10": false,
        "stationT5": false,
        "stationT8": false,
        "stationT12": false,
        "stationJ3": false,
        "stationJ1": false,
        "stationJ2": false,
        "stationJ4": false,
      },

    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.getData();
    },
    getData() {
      this.resetError();
      this.loading = true;
      // let stationRequestList = [];
      // this.stationIdList.forEach((stationId) => {
      //   stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      // });

      // this.$http.all(stationRequestList).then(
      //   this.$http.spread((...resList) => {
      //     resList.forEach((res) => {
      //       this.setDataAndError(res.data);
      //       this.loading = false;
      //     });
      //   })
      // );

      for (let stationName in this.stationNameLoadingDict) {
        this.stationNameLoadingDict[stationName] = true;
      }

      this.$nextTick(() => {
        for (let stationName in this.stationNameStationIdDict) {
          this.getDataForStation(stationName);
        }

        setTimeout(() => {
          this.loading = false;
        }, 500);

      })


    },
    getDataForStation(stationName) {
      let stationId = this.stationNameStationIdDict[stationName];
      if (!stationId) {
        return;
      }

      this.stationNameLoadingDict[stationName] = true;
      this.$http.get('/deviceData/Station?stationId=' + stationId).then((res) => {
        this.setDataAndError(res.data);
        this.stationNameLoadingDict[stationName] = false;
      })
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel === "" && allowedMax === "") {
        //no humidity dehumidfiier
        if (runningFlag === "--" || runningFlag === null || runningFlag === undefined || isNaN(Number(runningFlag))) {
          result += "数据中断";
        } else if (runningFlag > 0) {
          result += "除湿机运行";
        } else if (runningFlag === 0) {
          result += "除湿机停止";
        }

        if (errorFlag === "--" || errorFlag === null || errorFlag === undefined || isNaN(Number(errorFlag))) {
          if (result.indexOf("数据中断") < 0) {
            result += ", 数据中断";
          }
        } else if (errorFlag > 0) {
          result += ", 故障报警";
        }
      } else {
        //normal dehumidifer (with humidity)
        if (errorLevel.toLowerCase() !== "warning") {
          if (runningFlag > 0) {
            result += ", 除湿机运行";
          } else if (runningFlag === 0) {
            result += ", 除湿机停止";
          }
        }

        if (errorFlag > 0) {
          result += ", 故障报警";
        }
      }

      return result;
    },
    hrefToScenario(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + "/dataHistory?bridgeId=" + this.bridgeId + "&scenarioId=" + id);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }

  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}

@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }

  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .sensor1:after {
          background: #c7798b;
        }

        .sensor2:after {
          background: #3376c7;
        }
      }

      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .default:after {
          background: #ffff00;
        }

        .running:after {
          background: #67dd34;
        }

        .stopped:after {
          background: #a0a0a0;
        }
      }

      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }

        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;

        i {
          font-size: 30px;
        }

        .dir-text {
          font-size: 20px;
        }
      }

      .left-dir {
        left: 185px;
      }

      .right-dir {
        flex-direction: row-reverse;
        right: 185px;
      }

      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/jiashao/bridgeLine.png");
        background-position-y: 100%;

        &.image-reversed {
          background-image: url("../../assets/image/jiashao/bridgeLineReversed.png");
        }

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .tower-name {
          border-radius: 50%;
          color: #344084;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 3px solid;
          width: 24px;
          height: 24px;
          padding-left: 1px;

          &.tower-name-z3 {
            position: absolute;
            top: 274px;
            left: 264px;
          }

          &.tower-name-z4 {
            position: absolute;
            top: 274px;
            left: 620px;
          }

          &.tower-name-z5 {
            position: absolute;
            top: 274px;
            left: 975px;
          }

          &.tower-name-z6 {
            position: absolute;
            top: 274px;
            left: 184px;
          }

          &.tower-name-z7 {
            position: absolute;
            top: 274px;
            left: 540px;
          }

          &.tower-name-z8 {
            position: absolute;
            top: 274px;
            left: 895px;
          }
        }

        .stati {
          position: absolute;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);

            &:before {
              background-color: #ed6a5a;
            }

            &>p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 96%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }

            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .bold {
              font-weight: 800;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }

              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            &>p {
              margin: 0;
              white-space: nowrap;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.sensor1 {
            background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }

          &.sensor2 {
            background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .station-block-z3-top {
          top: 115px;
          left: 269px;
        }

        .station-block-z3-mid {
          top: 202px;
          left: 269px;
        }

        .station-block-z4-top {
          top: 115px;
          left: 625px;
        }

        .station-block-z4-mid {
          top: 202px;
          left: 625px;
        }

        .station-block-z5-top {
          top: 115px;
          left: 979px;
        }

        .station-block-z5-mid {
          top: 202px;
          left: 979px;
        }

        .station-block-rigidhinge-up {
          top: 202px;
          left: 1146px;
        }

        .sta-z3-top {
          top: 108px;
          left: 282px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -83px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z3-mid {
          top: 222px;
          left: 150px;

          &::before {
            bottom: 34px;
            left: 89px;
            width: 60px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 30px;
          }

          .state-info {
            right: -81px;
            top: -62px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z4-top {
          top: 108px;
          left: 636px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -83px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z4-mid {
          top: 222px;
          left: 505px;

          &::before {
            bottom: 34px;
            left: 89px;
            width: 60px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 30px;
          }

          .state-info {
            right: -81px;
            top: -62px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z5-top {
          top: 108px;
          left: 991px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -83px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z5-mid {
          top: 222px;
          left: 860px;

          &::before {
            bottom: 34px;
            left: 89px;
            width: 60px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 30px;
          }

          .state-info {
            right: -81px;
            top: -62px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-rigidhinge-up-up {
          top: 222px;
          left: 1056px;

          &::before {
            bottom: 20px;
            left: 92px;
            width: 20px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -185px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-rigidhinge-up-down {
          top: 222px;
          left: 1056px;

          &::before {
            bottom: -10px;
            left: 92px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -185px;
            top: 58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .station-block-rigidhinge-down {
          top: 202px;
          left: 0px;
        }

        .station-block-z6-top {
          top: 115px;
          left: 188px;
        }

        .station-block-z6-mid {
          top: 202px;
          left: 188px;
        }

        .station-block-z7-top {
          top: 115px;
          left: 542px;
        }

        .station-block-z7-mid {
          top: 202px;
          left: 542px;
        }

        .station-block-z8-top {
          top: 115px;
          left: 898px;
        }

        .station-block-z8-mid {
          top: 202px;
          left: 898px;
        }

        .sta-rigidhinge-down-up {
          top: 222px;
          left: -90px;

          &::before {
            bottom: 20px;
            left: 92px;
            width: 20px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -185px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-rigidhinge-down-down {
          top: 222px;
          left: -90px;

          &::before {
            bottom: -10px;
            left: 92px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -185px;
            top: 58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z6-top {
          top: 108px;
          left: 199px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -83px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z6-mid {
          top: 222px;
          left: 73px;

          &::before {
            bottom: 34px;
            left: 108px;
            width: 60px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 62px;
            left: 145px;
            width: 30px;
          }

          .state-info {
            right: -350px;
            top: -63px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z7-top {
          top: 108px;
          left: 554px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -83px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z7-mid {
          top: 222px;
          left: 428px;

          &::before {
            bottom: 34px;
            left: 108px;
            width: 60px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 62px;
            left: 145px;
            width: 30px;
          }

          .state-info {
            right: -350px;
            top: -63px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z8-top {
          top: 108px;
          left: 910px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -83px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }

        .sta-z8-mid {
          top: 222px;
          left: 783px;

          &::before {
            bottom: 34px;
            left: 108px;
            width: 60px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 62px;
            left: 145px;
            width: 30px;
          }

          .state-info {
            right: -350px;
            top: -63px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 175px;
          }
        }
      }
    }
  }
}
</style>